import React from 'react';
import { makeStyles, MenuItem } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      '&:hover, &:active, &:focus': {
        backgroundColor: theme.palette.common.lightGreen,
      },
      '&$selected': {
        backgroundColor: theme.palette.common.lightGreen,
        '&:hover, &:active, &:focus': {
          backgroundColor: theme.palette.common.lightGreen,
        },
      },
      fontWeight: '400',
    },
    selected: {
      backgroundColor: theme.palette.background.paper,
      '&:hover, &:active, &:focus': {
        backgroundColor: theme.palette.background.paper,
      },
    },
  };
});

const SelectMenuItem = React.forwardRef(({ children, className, ...props }, ref) => {
  const classes = useStyles();
  return (
    <MenuItem
      ref={ref}
      classes={{
        root: classes.root,
        selected: classes.selected,
      }}
      className={className}
      {...props}
    >
      {children}
    </MenuItem>
  );
});

export default SelectMenuItem;
